export interface RedirectToUrl {
    goTo(url: string): void;
}

export class DocumentRedirectToUrl implements RedirectToUrl {
    goTo(url: string) {
        document.location = url
    }
}